(function ($) {
  "use strict";

  var $shareToggle;
  var $shareMenu;
  var shareMenuOpenClass = "is-open";

  $(document).ready(function () {
    $shareToggle = $(".js-share-toggle");
    $shareMenu = $(".js-share-menu");

    pageUtils();
  });

  function pageUtils() {
    $shareToggle.on("click", function (e) {
      e.preventDefault();

      if ($shareMenu.hasClass(shareMenuOpenClass)) {
        closePageUtilsShare();
      } else {
        openPageUtilsShare();
      }
    });

    $("#page-utilities").show();
  }

  function openPageUtilsShare() {
    $shareMenu.addClass(shareMenuOpenClass);

    $shareToggle.attr("aria-expanded", "true");

    // close when depressing the Esc key
    $(document).on("keyup.share", function (e) {
      if (e.which == 27) {
        // escape key maps to keycode `27`
        closePageUtilsShare();
      }
    });
  }

  function closePageUtilsShare() {
    $shareMenu.removeClass(shareMenuOpenClass);
    $shareToggle.attr("aria-expanded", "false");

    // remove the Esc key
    $(document).off(".share");
  }
})(jQuery);
